<div class="modal-header">
  <h4 class="fw-semibold modal-title text-center">
    {{ "Change Password" | translate }}
  </h4>

  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="passwordForm" class="text-start mb-3">
    <div class="mb-3">
      <label class="form-label" for="current-password"
        >{{ "Current Password" | translate }}
      </label>
      <input
        type="password"
        formControlName="current_password"
        id="current-password"
        name="current-password"
        class="form-control"
        [ngClass]="{
          'is-invalid':
            submit && passwordForm.controls['current_password'].errors,
          'is-valid':
            submit && !passwordForm.controls['current_password'].errors
        }"
        [placeholder]="'Old Password' | translate"
      />
      <div class="valid-feedback">{{ "Looks good" | translate }}</div>
      <div class="invalid-feedback">
        {{ "Please provide a valid password" | translate }}
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label" for="new-password"
        >{{ "Create New Password" | translate }}
        <small class="text-primary ms-1">{{
          "Must be at least 8 characters" | translate
        }}</small>
      </label>
      <input
        type="password"
        formControlName="new_password"
        id="new-password"
        name="new-password"
        class="form-control"
        [ngClass]="{
          'is-invalid': submit && passwordForm.controls['new_password'].errors,
          'is-valid': submit && !passwordForm.controls['new_password'].errors
        }"
        [placeholder]="'New Password' | translate"
      />
      <div class="valid-feedback">{{ "Looks good" | translate }}</div>
      @if (hasError('new_password', 'minlength')) {
      <div class="invalid-feedback">
        {{ "Must be at least 8 characters" | translate }}
      </div>
      } @else {
      <div class="invalid-feedback">
        {{ "Please provide a valid password" | translate }}
      </div>
      }
    </div>
    <div class="mb-3">
      <label class="form-label" for="re-password"
        >{{ "Reenter New Password" | translate }}
        <small class="text-primary ms-1">{{
          "Must be at least 8 characters" | translate
        }}</small>
      </label>
      <input
        type="password"
        formControlName="confirm_password"
        id="re-password"
        name="re-password"
        class="form-control"
        [placeholder]="'Reenter Password' | translate"
        [ngClass]="{     
        'is-invalid': submit && passwordForm.controls['confirm_password'].errors || passwordForm.errors?.['PasswordNoMatch'],
      'is-valid': submit && !passwordForm.controls['confirm_password'].errors && !passwordForm.errors?.['PasswordNoMatch']
      }"
      />
      <div class="valid-feedback">{{ "Looks good" | translate }}</div>
      @if (hasError('confirm_password', 'required')) {
      <div class="invalid-feedback">
        {{ "Please provide a valid password" | translate }}
      </div>
      } @else if (hasError('confirm_password', 'minlength')) {
      <div class="invalid-feedback">
        {{ "Must be at least 8 characters" | translate }}
      </div>
      } @else if(passwordForm.errors && passwordForm.errors['PasswordNoMatch'])
      {
      <div class="invalid-feedback">
        {{ "Passwords do not match!" | translate }}
      </div>

      }
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
    {{ "Close" | translate }}
  </button>
  <button (click)="updatePassword()" class="btn btn-primary" type="button">
    @if (isLoading) {
    <span
      class="spinner-grow spinner-grow-sm me-1"
      role="status"
      aria-hidden="true"
    ></span>
    {{ "Changing" | translate }}
    } @else {
    {{ "Change Password" | translate }}
    }
  </button>
</div>
